var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var Dots = function (_a) {
    var step = _a.step, setStep = _a.setStep;
    var totalSteps = [1, 2, 3];
    return (_jsx("div", __assign({ className: "dots" }, { children: totalSteps.map(function (dotStep) { return (_jsx("div", { onClick: function () { return setStep(dotStep); }, className: "dot ".concat(step === dotStep ? 'active' : ''), style: {
                width: '19px',
                height: '19px',
                borderRadius: '50%',
                backgroundColor: step === dotStep ? '#F15E2B' : '#fff',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
            } }, dotStep)); }) })));
};
export default Dots;
